/**
 * נתיבי הצעה ציבורית — source of truth ל־URL (טיסה מול הזמנה דינמית עם מלון/חבילה).
 * /flights/offer/:id = הצעת טיסה בלבד (flights_new_proposal)
 * /dynamic/offer/:id = יתר הדינמיים (אחורה־תאימות)
 */

import { isFlightsNewProposalPackage } from "./dynamicPackageDisplayMode";

export const PUBLIC_FLIGHT_OFFER_SEGMENT = "flights/offer";
export const PUBLIC_DYNAMIC_OFFER_SEGMENT = "dynamic/offer";

/**
 * @param {string} [origin] — לדוגמה window.location.origin; אם ריק מחזיר path יחסי
 * @param {string|number} id
 * @param {{ flightOnly?: boolean }} [opts]
 * @returns {string}
 */
export function buildPublicFlightOrDynamicOfferUrl(origin, id, opts = {}) {
  const { flightOnly = false } = opts;
  const safeId = id != null ? String(id) : "";
  if (!safeId) return origin ? `${origin}/` : "/";
  const seg = flightOnly ? PUBLIC_FLIGHT_OFFER_SEGMENT : PUBLIC_DYNAMIC_OFFER_SEGMENT;
  const path = `/${seg}/${encodeURIComponent(safeId)}`;
  if (origin == null || String(origin).trim() === "") return path;
  return `${String(origin).replace(/\/$/, "")}${path}`;
}

/**
 * @param {object|null|undefined} dynamicEntity — שורה מ־getDynamicOrder או context
 * @returns {boolean}
 */
export function isPublicOfferFlightOnly(dynamicEntity) {
  return isFlightsNewProposalPackage(dynamicEntity);
}

/**
 * Public share / customer offer URLs, including locale prefixes (`/he/dynamic/offer/...`).
 */
export function isPublicOfferPathname(pathname) {
  const p = String(pathname || "");
  return (
    p.includes("/dynamic/offer/") ||
    p.includes("/flights/offer/") ||
    p.includes("/hotel/offer/") ||
    p.includes("/offers/public/")
  );
}
